var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94737 0H0.631579C0.284211 0 0 0.284211 0 0.631579C0 0.978947 0.284211 1.26316 0.631579 1.26316H6.94737C7.29474 1.26316 7.57895 0.978947 7.57895 0.631579C7.57895 0.284211 7.29474 0 6.94737 0ZM6.94737 2.52632H0.631579C0.284211 2.52632 0 2.81053 0 3.15789C0 3.50526 0.284211 3.78947 0.631579 3.78947H6.94737C7.29474 3.78947 7.57895 3.50526 7.57895 3.15789C7.57895 2.81053 7.29474 2.52632 6.94737 2.52632ZM0.631579 6.31579H4.42105C4.76842 6.31579 5.05263 6.03158 5.05263 5.68421C5.05263 5.33684 4.76842 5.05263 4.42105 5.05263H0.631579C0.284211 5.05263 0 5.33684 0 5.68421C0 6.03158 0.284211 6.31579 0.631579 6.31579ZM10.1053 0C9.41053 0 8.8421 0.568421 8.8421 1.26316V5.16632C8.64632 5.09684 8.43158 5.05263 8.21053 5.05263C7.04842 5.05263 6.13895 6.08842 6.34737 7.28842C6.48 8.05263 7.10526 8.67789 7.86947 8.81053C9.06947 9.01895 10.1053 8.10947 10.1053 6.94737V1.26316H11.3684C11.7158 1.26316 12 0.978947 12 0.631579C12 0.284211 11.7158 0 11.3684 0H10.1053Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.f68f1f4206db892808cc8772cc647aa6.svg";
export { ForwardRef as ReactComponent };